import * as coursesUserAction from "../actions/lmsUserAction";
import { lmsUserType } from "../constants/lmsUserType";
import {
  startCoursess,
  getUserCoursesList,
  getUserCoursesListSafetyLog,
} from "../../services/coursesService";
import { call, put, takeLatest } from "redux-saga/effects";
import { apiError } from "../../utils/helper";

export function* getUserCoursesListSaga(params) {
  try {
    const { data, status, error } = yield call(getUserCoursesList, params);
    if (!data && status !== 200) throw apiError(error);
    const coursesUserPage = lmsUserType.COURSES_USER__PAGE;
    if (!params.data.isSendMail) {
      yield put(
        coursesUserAction.getUserCoursesListSuccess({
          coursesUserPage,
          data,
        })
      );
    } else {
      yield put(coursesUserAction.getUserCoursesListEmailSuccess());
    }
  } catch (error) {
    const data =
      error && error.message
        ? error
        : { message: error || "Get Lesson List Failed" };
    yield put(coursesUserAction.getUserCoursesListFailure(data));
  }
}

export function* startCourseSaga(param) {
  const payload = param.data;
  try {
    const { data, status, error } = yield call(startCoursess, payload);
    if (!data && status !== 200) throw apiError(error);
    const startCourse = coursesUserAction.startCourse;
    yield put(
      coursesUserAction.startCourseSuccess({
        startCourse,
        data,
      })
    );
  } catch (error) {
    const data =
      error && error.message
        ? error
        : { message: error || "Start Course Failed" };
    yield put(coursesUserAction.startCourseFailure(data));
  }
}

export function* getUserCoursesListSafetyLogSaga(params) {
  try {
    const { data, status, error } = yield call(
      getUserCoursesListSafetyLog,
      params
    );
    if (!data && status !== 200) throw apiError(error);
    const coursesUserPage = lmsUserType.USER_COURSES_LIST_PAGE;
    if (!params.data.isSendMail) {
      yield put(
        coursesUserAction.getUserCoursesListSafetyLogSuccess({
          coursesUserPage,
          data,
        })
      );
    } else {
      yield put(coursesUserAction.getUserCoursesListEmailSuccess());
    }
  } catch (error) {
    const data =
      error && error.message
        ? error
        : { message: error || "Get Lesson List Failed" };
    yield put(coursesUserAction.getUserCoursesListSafetyLogFailure(data));
  }
}

const myUserCoursesSaga = [
  takeLatest(lmsUserType.GET_USER_COURSES_LIST_PENDING, getUserCoursesListSaga),
  takeLatest(lmsUserType.POST_START_COURSES_PENDING, startCourseSaga),
  takeLatest(
    lmsUserType.GET_USER_COURSES_LIST_SAFETY_LOG_PENDING,
    getUserCoursesListSafetyLogSaga
  ),
];

export default myUserCoursesSaga;
